import {apiEsToken} from '@local/apis/esToken';
import {FirebaseUser} from '@local/logics/firebase/user';
import dayjs from 'dayjs';
import {elasticsearchActions} from '@local/redux/slice/elasticsearch';
import {DispatchHolder} from '@local/logics/global/dispatchHolder';

export class TokenGetInteractor {
  private static token?: {
    uid: string;
    es_token: string;
    expires_at: ISOString;
  } = undefined;

  constructor() {}

  // ログイン直後のチェックロジックとreduxの非同期の都合で2回取りかねないので外から渡せるようにする
  static setToken = (arg: {uid: string; es_token: string; expires_at: ISOString}) => {
    TokenGetInteractor.token = arg;
    TokenGetInteractor.updateState({...arg});
  };

  handle = async (): Promise<(Token & {updated?: true}) | undefined> => {
    try {
      // ログインユーザーを元に認証済みペルソナ一覧が取れるようにすると横断もいける。
      const uid = FirebaseUser.user?.uid;
      if (!uid) {
        if (TokenGetInteractor.token) {
          TokenGetInteractor.token = undefined;
          this.clearState();
        }
        return undefined;
      }
      if (!TokenGetInteractor.token) {
        return await this.get(uid);
      }
      if (TokenGetInteractor.token.uid !== uid) {
        return await this.get(uid);
      }
      const expire = dayjs(TokenGetInteractor.token.expires_at);
      const now = Date.now();
      // PIT作って連続実行っていうのが登場したから早めにリフレッシュしないと怖い
      // PITの有効期限を1分にしてるし、1分切ってたらリフレッシュ・・・かなぁ
      if (expire.isBefore(now + 60000)) {
        return await this.get(uid);
      }
      return {...TokenGetInteractor.token};
    } catch (e) {
      console.error('err', e);
      throw e;
    }
  };
  private get = async (uid: string): Promise<Token & {updated?: true}> => {
    const {
      data: {es_token, expires_at},
    } = await apiEsToken();
    TokenGetInteractor.token = {
      uid,
      es_token,
      expires_at,
    };
    const next = {...TokenGetInteractor.token};
    this.updateState(next);
    return next;
  };

  private clearState = () => {
    DispatchHolder.dispatch(elasticsearchActions.clear());
  };
  private updateState = (token: {uid: string; es_token: string; expires_at: ISOString}) => {
    TokenGetInteractor.updateState(token);
  };
  private static updateState = (token: {uid: string; es_token: string; expires_at: ISOString}) => {
    DispatchHolder.dispatch(
      elasticsearchActions.set({
        elastic: {
          es_token: token.es_token,
          expires_at: token.expires_at,
          uid: token.uid,
        },
      })
    );
  };
}
type Token = {
  uid: string;
  es_token: string;
  expires_at: ISOString;
};
